import React, { FC, useState } from 'react';

import { Radio, RadioGroup } from '../../components/radio-group/index';
import { arrayOfTeamTab, TeamTabType } from '../../types/team.types';
import { MembersTab } from './members/members-tab';
import { VacationsTab } from './vacations/vacations-tab';

export const Team: FC = () => {
  const [tab, setTab] = useState<TeamTabType>(TeamTabType.MEMBERS);

  return (
    <div className="flex w-full flex-col gap-6">
      <RadioGroup
        className="h-fit w-fit divide-x divide-gray-200 overflow-hidden rounded border border-gray-200"
        onChange={(value: TeamTabType) => setTab(value)}
        value={tab}
      >
        {arrayOfTeamTab.map(([tabKey, label]) => (
          <Radio
            className="flex h-9 items-center justify-center px-6 text-sm font-[450] text-[#858593] data-[checked]:bg-brand-25 data-[checked]:font-[550] data-[checked]:text-[#172335]"
            key={tabKey}
            styleType="NONE"
            value={tabKey}
          >
            {label}
          </Radio>
        ))}
      </RadioGroup>

      {tab === TeamTabType.MEMBERS ? <MembersTab /> : <VacationsTab />}
    </div>
  );
};
